
export default function subscriptionOptions(data, subscriptions) {
  // Person has opted out of everything
  if (data.unsubscribed && data.unsubscribed === 'true') {
    return subscriptions.map((sub) => {
      return Object.assign({}, sub, { checked: true })
    })
  }

  // Set checkboxes with current settings
  return subscriptions.map((sub) => {
    const currentSetting = data[sub.attribute]
    const value = (currentSetting) ? stringToBoolean(data[sub.attribute]) : false
    return Object.assign({}, sub, {
      checked: value
    })
  })
}

function stringToBoolean(string) {
  switch (string.toLowerCase().trim()) {
    case "true": case "yes": case "1": return true
    case "false": case "no": case "0": case null: return false
    default: return Boolean(string)
  }
}
